import { render, staticRenderFns } from "./Sealed.vue?vue&type=template&id=4498d49a&scoped=true&"
import script from "./Sealed.vue?vue&type=script&lang=js&"
export * from "./Sealed.vue?vue&type=script&lang=js&"
import style0 from "./Sealed.vue?vue&type=style&index=0&id=4498d49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498d49a",
  null
  
)

export default component.exports